import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import shiftService from "../../services/ShiftService";


export const getShiftList = createAsyncThunk(
    "shift/GetShiftList",
    async (_,{ rejectWithValue }) => {
        try {
            const response = await shiftService.GetShiftList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to get shift list"
            );
        }
    }
)

export const addShift = createAsyncThunk(
    "shift/addShift",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await shiftService.AddShift(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to add shift"
            );
        }
    }
)

export const updateShift = createAsyncThunk(
    "bank/updateShift",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await shiftService.UpdateShift(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message || 
                error.message || 
                "Failed to update shift"
            );
        }
    }
)

const initialState = {
  shifts: [],

  loading: false,

  saving: false,

  error: null,
  success: false,
};

const shiftSlice = createSlice({
    name: "shift",
    initialState,
    reducers: {
        clearShiftError: (state) => {
            state.error = null;
        },

        clearShiftSuccess: (state) => {
            state.success = false;
        },

        clearShifts: (state) => {
            state.shifts = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get designation list
        .addCase(
            getShiftList.pending,
            (state) => {
                state.loading = true;
                state.error = null;
            }
        )
        .addCase(
            getShiftList.fulfilled,
            (state, action) => {
                state.loading = false;
                state.shifts = action.payload;
            }
        )
        .addCase(
            getShiftList.rejected,
            (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load shifts";
            }
        )

        // Add Designation
        .addCase(addShift.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addShift.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(addShift.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add shift"
        })

        // Update Designation
        .addCase(updateShift.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateShift.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(updateShift.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update shift"
        })
    }
})

export const {
    clearShiftError,
    clearShiftSuccess,
    clearShifts
} = shiftSlice.actions;

export default shiftSlice.reducer;